import { render, staticRenderFns } from "./pointModel.vue?vue&type=template&id=5f28ba9d&scoped=true&"
import script from "./pointModel.vue?vue&type=script&lang=js&"
export * from "./pointModel.vue?vue&type=script&lang=js&"
import style0 from "./pointModel.vue?vue&type=style&index=0&id=5f28ba9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28ba9d",
  null
  
)

export default component.exports